"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require("babel-runtime/helpers/extends");

var _extends3 = _interopRequireDefault(_extends2);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Search = function Search(props) {
  return _react2.default.createElement(
    "svg",
    (0, _extends3.default)({ width: 18, height: 18, viewBox: "0 0 18 18" }, props),
    _react2.default.createElement("path", { d: "M12.016 10.979l4.725 4.87-1.346 1.305-4.69-4.834a5.853 5.853 0 0 1-3.517 1.172c-3.31 0-5.985-2.756-5.985-6.144 0-3.389 2.674-6.145 5.985-6.145 3.31 0 5.984 2.756 5.984 6.145a6.229 6.229 0 0 1-1.156 3.63zm-4.828.92c2.42 0 4.39-2.033 4.39-4.551 0-2.519-1.97-4.551-4.39-4.551s-4.391 2.032-4.391 4.55c0 2.52 1.971 4.551 4.39 4.551z" })
  );
};

exports.default = Search;


//////////////////
// WEBPACK FOOTER
// ./~/caligram-react/dist/icons/Search.js
// module id = 698
// module chunks = 0